module.exports = __webpack_public_path__ + "static/media/logo-internal.8bb9d5cd.png";